import { isDefined } from "@clipboard-health/util-ts";
import { Callout, type IconType } from "@src/appV2/redesign/system/ui-components";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_TRAVEL_BLOCKS_PATH } from "../../ShiftDiscovery/paths";
import { useShiftModalsDataContext } from "../../ShiftDiscovery/useShiftModalsDataContext";
import { useTravelPageRollout } from "./useTravelPageRollout";

const allowedIcons = new Set<IconType>(["airplane-globe", "airplane-takeoff", "airplane", "plane"]);

export function ShiftTravelBlockCallout() {
  const history = useHistory();

  const { enabled, iconName } = useTravelPageRollout();

  const { baseNavigationPath } = useShiftModalsDataContext();

  if (!enabled) {
    return null;
  }

  return (
    <Callout
      title="Travel Blocks"
      iconType={
        isDefined(iconName) && allowedIcons.has(iconName as IconType)
          ? (iconName as IconType)
          : "airplane-takeoff"
      }
      onClick={() => {
        history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_TRAVEL_BLOCKS_PATH}`);
      }}
    />
  );
}
